export default [
  {
    label: 'Recurring',
    value: 'Recurring',
  },
  {
    label: 'Non-recurring',
    value: 'NonRecurring',
  },
];
